export const TIME_TRY_TO_SLEEP = 'sleep_efficiency_time_try_to_sleep';
export const TIME_FINAL_AWAKENING = 'sleep_efficiency_time_final_awakening';
export const TIME_GET_OUT_OF_BED = 'sleep_efficiency_time_get_out_of_bed';
export const TIME_INTO_BED = 'sleep_efficiency_time_into_bed';
export const TO_FALL_ASLEEP_TOTAL_TIME =
  'sleep_efficiency_to_fall_asleep_total_time'; // WARNING minutes
export const AWAKENINGS_IN_NIGHT = 'sleep_efficiency_awakenings_in_night';
export const AWAKENINGS_TOTAL_TIME = 'sleep_efficiency_awakenings_total_time'; // WARNING minutes
export const SLEEP_QUALITY = 'sleep_efficiency_sleep_quality';
